import { render, staticRenderFns } from "./BLZNC03Component.vue?vue&type=template&id=72c5db7d&scoped=true&"
import script from "./BLZNC03Component.vue?vue&type=script&lang=js&"
export * from "./BLZNC03Component.vue?vue&type=script&lang=js&"
import style0 from "./BLZNC03Component.vue?vue&type=style&index=0&id=72c5db7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5db7d",
  null
  
)

export default component.exports